import API from '../sunpalApi';
const ENTITY = 'rendered';

export const getTemplatecontent = (id) =>
    API.get(`/api/v1/${ENTITY}-content/`, {
        params: {
            pk: id,
        },
    });
